export function isWebflowEditor(): boolean {
  const firstChild = document.body.firstElementChild;
  return (
    firstChild instanceof HTMLElement &&
    firstChild.classList.contains("w-editor-publish-node")
  );
}

export function handleEditor(
  onEditorView: ((isEditor: boolean) => void) | null = null
) {
  let previousState = isWebflowEditor();
  const isEditor = previousState;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        const newIsEditor = isWebflowEditor();
        if (newIsEditor !== previousState) {
          console.log("Editor state changed to:", newIsEditor);
          if (onEditorView) {
            onEditorView(newIsEditor);
          }
          previousState = newIsEditor;
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: false,
  });

  if (onEditorView) {
    onEditorView(isEditor);
  }

  return isEditor;
}
